<template>
  <div class="absolute bottom-0 left-0 right-0 bg-white rounded-b-2xl z-20" style="border-top: 1px solid rgb(229, 229, 229);">
    <!-- Navigation Buttons -->
    <div class="py-2">
      <div class="flex justify-around items-center">
        <NavButton
          screen-name="HomeScreen"
          :current-screen="currentScreen"
          icon-component="AkHomeAlt1"
          label="Home"
          inactive-color="#737373"
          @navigate="navigate"
        />
        
        <NavButton
          screen-name="ChatScreen"
          :current-screen="currentScreen"
          icon-component="AkChatDots"
          label="Chat"
          inactive-color="#6b7280"
          @navigate="navigate"
        />
        
        <NavButton
          screen-name="FAQScreen"
          :current-screen="currentScreen"
          icon-component="AkQuestion"
          label="FAQ"
          inactive-color="#737373"
          @navigate="navigate"
        />
        
        <!-- Conditional Meeting Button -->
        <NavButton
          v-if="styles.showMeeting"
          screen-name="MeetingScreen"
          :current-screen="currentScreen"
          icon-component="AkClock"
          label="Meeting"
          inactive-color="#737373"
          @navigate="navigate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NavButton from './NavButton.vue';

export default {
  name: 'NavBar',
  components: {
    NavButton
  },
  props: {
    currentScreen: {
      type: String,
      required: true
    },
    styles: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    navigate(screenName) {
      this.$emit('change-screen', screenName);
    }
  }
};
</script>